module.exports = __webpack_public_path__ + "img/message_icon_dark.7750121e.svg";